import { PathOptions } from "leaflet";

export const palette = [
  "#e6194b",
  "#3cb44b",
  "#4363d8",
  "#f58231",
  "#911eb4",
  "#42d4f4",
  "#f032e6",
  "#bfef45",
  "#fabed4",
  "#469990",
  "#dcbeff",
  "#9a6324",
  "#fffac8",
  "#800000",
  "#aaffc3",
  "#808000",
  "#ffd8b1",
  "#000075",
  "#a9a9a9",
];

export function hashIndex(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash % palette.length;
}

export const apl_pe_observatorio = (feature: any): PathOptions => {
  const apls = feature.properties?.apls;

  if (!apls) {
    return {
      color: "#000000",
      weight: 1,
      opacity: 0.4,
      fillOpacity: 0,
    };
  }

  return {
    color: "#000000",
    weight: 2,
    opacity: 0.8,
    fillColor: palette[hashIndex(apls)],
    fillOpacity: 0.6,
  };
};
